import React, { useState } from 'react';
import { useAdminConfig } from '../../hooks/useAdminConfig';
import { Card } from '../../components/ui/Card';
import { CustomFieldBuilder } from '../../components/admin/CustomFieldBuilder';
import { LoadingSpinner } from '../../components/ui/Feedback';
import { EntityType } from '../../types/admin';

export const CustomFieldsPage: React.FC = () => {
  const { customFields, isLoading, createCustomField, deleteCustomField } = useAdminConfig();
  const [entityType, setEntityType] = useState<EntityType>('complaint');

  if (isLoading) return <LoadingSpinner size="lg" text="Loading Custom Fields..." />;

  const entityTypes: { value: EntityType; label: string }[] = [
    { value: 'complaint', label: 'Complaint' },
    { value: 'work_order', label: 'Work Order' },
    { value: 'vendor', label: 'Vendor' },
    { value: 'user', label: 'User' },
  ];

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-slate-100">Custom Fields Builder</h3>
        <p className="text-xs text-slate-400">Define dynamic fields per entity type and category</p>
      </div>

      <div className="flex items-center gap-2">
        <label className="text-xs font-medium text-slate-400">Entity Type:</label>
        {entityTypes.map(et => (
          <button key={et.value} onClick={() => setEntityType(et.value)}
            className={`px-3 py-1.5 text-xs rounded-lg transition-colors ${
              entityType === et.value ? 'bg-sky-500/10 text-sky-400 border border-sky-500/30' : 'text-slate-400 hover:text-slate-200 border border-slate-700'
            }`}>
            {et.label}
          </button>
        ))}
      </div>

      <Card title={`Custom Fields for: ${entityType.replace('_', ' ')}`}>
        <CustomFieldBuilder
          fields={customFields}
          entityType={entityType}
          onSave={async (data) => { await createCustomField(data); }}
          onDelete={async (id) => { await deleteCustomField(id); }}
        />
      </Card>
    </div>
  );
};
